import React from "react";
import { hot } from 'react-hot-loader';

import styles from './CheckAllInterface.module.css';

const copyObject = (data) => {
  return Object.assign({}, JSON.parse(JSON.stringify(data)));
}

const CheckAllInterface = ({ setting, setSetting }) => {
  const checkAll = () => {
    const newSetting = copyObject(setting);

    for (const path in newSetting.contents) {
      newSetting.contents[path] = true;
    }
    setSetting(newSetting);
  }

  const uncheckAll = () => {
    const newSetting = copyObject(setting);

    for (const path in newSetting.contents) {
      newSetting.contents[path] = false;
    }
    setSetting(newSetting);
  }

  return (
    <div className={styles.interface}>
      <input type="button" onClick={checkAll} value="全て選択" />&nbsp;
      <input type="button" onClick={uncheckAll} value="全て選択解除" />
    </div>
  )
}

export default hot(module)(CheckAllInterface);
